<app-left-side-nav></app-left-side-nav>
<app-header ></app-header>
<!-- page content area start -->

<div class="afterLoginPageContainer" translate="no">
    <div class="container px-0">
        <div class="mainContent"
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollUpDistance]="1.5"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScrollDown()">
            <div class="catalog-header" [ngClass]="{'mobile-padd':!isAuthenticated}">
                <div class="top-bar">
                    <div class="wrapper">
                        <button class="back-btn" (click)="onClickBack()">
                            <i class="fa fa-arrow-left"></i>
                        </button>
                        <div class="title-section" *ngIf="paramsToFetchData.pavilion_code"> 
                            <div class="logo">
                                <img [src]="pavilionImgUrl" [alt]="pavilionName" />
                            </div>
                            <div class="info">
                                <h2 class="title">{{ pavilionName }}</h2>
                                <p>{{ companiesList.companies_count }}  {{ companiesList.companies_count <= 1 ? 'Company' : 'Companies' }} |
                                     {{ companiesList.products_count }} {{ companiesList.products_count <= 1 ? 'Product' : 'Products' }} </p>
                            </div>
                        </div>
                        <div class="title-section" *ngIf="paramsToFetchData.search && !paramsToFetchData.category && !paramsToFetchData.pavilion_code">
                            <div class="info">
                                <h2 class="title"><span class="txt">Search results for:</span> "{{ searchText }}" </h2>
                               
                            </div>
                        </div>

                        <div class="title-section" *ngIf="paramsToFetchData.category"> 
                            <div class="logo">
                                <img [src]="categoryImgUrl" [alt]="categoryName" />
                            </div>
                            <div class="info">
                                <h2 class="title">{{ categoryName }}</h2>
                                <p>{{ companiesList.companies_count }}  {{ companiesList.companies_count <= 1 ? 'Company' : 'Companies' }} |
                                     {{ companiesList.products_count }} {{ companiesList.products_count <= 1 ? 'Product' : 'Products' }} </p>
                            </div>
                        </div>
                    </div>
                    <div class="icons">
                        <i class="fa-regular fa-circle-check" (click)="openWishlist()" *ngIf="isAuthenticated"></i>
                        <i class="fa fa-search" id="searchIcon" (click)="openFloatingSearch()"></i>
                    </div>
                </div>

                <!-- Floating Search Bar -->
                <div class="floating-search" id="floatingSearch" [class.active]="isSearchOpen">
                    <div class="search-container">
                        <i class="fa fa-search" (click)="onSearchIconClick()"></i>
                        <input type="text" 
                        placeholder="Search..." 
                        id="searchInput" 
                        [(ngModel)]="searchText"
                        (ngModelChange)="onSearchInput()"
                        #searchInput 
                        />
                        <i class="fa fa-times" id="closeSearch" (click)="closeFloatingSearch()"></i>
                    </div>
                </div>
            </div>           
            <div class="tab-content" *ngIf="isDataLoaded" [ngClass]="{'mobile-mt':!isAuthenticated}">
                <div class="my-4 px-3">
                    <button (click)="viewLayout()" class="view-layout-btn w-100">View Layout</button>
                </div>
                <div class="title-section" *ngIf="paramsToFetchData.search 
                && (paramsToFetchData.category || paramsToFetchData.pavilion_code)">
                    <div class="info">
                        <h2 class="title"> <span class="txt">Search results for:</span> "{{ searchText }}" </h2>
                       
                    </div>
                </div>

                <div class="ads-outer">
                    <app-catalogue-ads [adsPavilionCode]="paramsToFetchData.pavilion_code ?? ''"></app-catalogue-ads>
                </div>
                
                <div class="companies-list" *ngIf="companiesList.list && companiesList.list.length > 0; else noCompanyTemplate">
                    <div class="row mx-0">
                        <div class="col-12 p-0">
                            <div class="card mb-3" *ngFor="let company of companiesList.list; let i = index; trackBy: trackByIndex" (click)="goToCompanyDetails(company.encoded_company_id, company.user_id)"> 
                                <div class="company-logo">
                                    <a >
                                        <img [src]="company.image_bigthumb_url" class="img-fluid"
                                            alt="Company Logo"
                                            onerror="this.src='/assets/images/default-profile-organization.jpg'">
                                    </a>
                                </div>
                                <div class="card-body">
                                    <h5 class="card-title">{{company.brandname}}</h5>
                                    <p class="card-text">{{company.product_count}} {{ company.product_count <= 1 ? 'Product' : 'Products' }}</p>
                               
                                    <h6 *ngIf="hasStandNumbers(company) " class="stall-no">Stall No. <b class="ms-2">{{ company.stand_numbers }}</b></h6>
                                </div>
                            </div>

                            <div class="section-loader text-center mx-auto" *ngIf="isLoadingMore">
                                <div class="spinner-border text-success" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            </div>          
                        </div>
                    </div>
                </div>
                <div class="catlogWrapper" (click)="goToTicketPage()" *ngIf="this.eventDetails?.allow_to_register === 1">
                    <img src="/assets/images/buy_your_ticket.png" alt="Go To Digital Catalogue" />
                </div>
                <ng-template #noCompanyTemplate>
                    <div class="no-data">
                        <p>No Records Found.</p>
                    </div>
                </ng-template>               
            </div>
            <div class="tabs">
                <div class="tabs-inner">
                    <div class="tab-item" (click)="goToProductsList()">
                        <img class="icon" src="/assets/images/product-icon.png" alt="product icon" />
                        <span>Products</span>
                    </div>
                    <div class="tab-item active">
                        <img class="icon" src="/assets/images/company-icon.png" alt="company icon" />
                        <span>Companies</span>
                    </div>       
                </div>
            </div>
        </div>
    </div>
</div>
